import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./Navbar";
import StockDetails from "./StockDetails";
import TopSmartScoreStocks from "./TopSmartScoreStocks";
import Login from "./Login";
import ProtectedRoute from "./ProtectedRoute";
import TopAnalystsStocks from "./TopAnalystsStocks";
import TopAnalystsStocksCanada from "./TopAnalystsStocksCanada";
import TopSmartScoreStocksCanada from "./TopSmartScoreStocksCanada";

function App() {
  return (
    <div className="App">
      <div
        style={{
          minHeight: "calc(100vh - 56px)",
          padding: "8px",
          marginTop: "4em",
        }}
      >
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <TopSmartScoreStocks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/top-smart-score-stocks"
            element={
              <ProtectedRoute>
                <TopSmartScoreStocks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/top-smart-score-stocks-ca"
            element={
              <ProtectedRoute>
                <TopSmartScoreStocksCanada />
              </ProtectedRoute>
            }
          />
          <Route
            path="/top-analysts-stocks"
            element={
              <ProtectedRoute>
                <TopAnalystsStocks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/top-analysts-stocks-ca"
            element={
              <ProtectedRoute>
                <TopAnalystsStocksCanada />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stocks/:ticker"
            element={
              <ProtectedRoute>
                <StockDetails />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<Login />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
